import { useEffect } from 'react';

import { cartStore } from '~/stores';

export const useRewardedPromocodesStatus = () => {
  useEffect(() => {
    cartStore.promotionStore.getRewardedPromocodesStatus();
  }, []);
};
